import { AxiosResponse } from 'axios';

import { CreatePropertyRequestType, FetchPropertiesRequestType } from './types';

import { CommonResponseType } from 'api/authApi';
import { GeneralResponseType } from 'common';
import { authServiceClient } from 'config';
import { PropertyType } from 'state';

export const fetchPropertiesRequest = (params: FetchPropertiesRequestType) => {
  return authServiceClient.get<
    GeneralResponseType<PropertyType>,
    AxiosResponse<GeneralResponseType<PropertyType>>,
    FetchPropertiesRequestType
  >(`/property`, { params });
};

export const fetchCertainPropertyRequest = (id: string) => {
  return authServiceClient.get<PropertyType, AxiosResponse<PropertyType>>(
    `/property/${id}`,
  );
};

export const createPropertyRequest = (data: CreatePropertyRequestType) => {
  return authServiceClient.post<
    PropertyType,
    AxiosResponse<PropertyType>,
    CreatePropertyRequestType
  >(`/property`, data);
};

export const editPropertyRequest = (
  property: CreatePropertyRequestType & { id: string },
) => {
  return authServiceClient.put<
    CommonResponseType,
    AxiosResponse<CommonResponseType>,
    CreatePropertyRequestType
  >(`/property/${property.id}`, property);
};

export const deletePropertyRequest = (id: string) => {
  return authServiceClient.delete<CommonResponseType, AxiosResponse<CommonResponseType>>(
    `/property/${id}`,
  );
};

export const uploadCsvRequest = (file: File) => {
  return authServiceClient.post<any, AxiosResponse<any>, { file: File }>(
    `/property/upload-csv`,
    { file },
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
};

export const uploadBulkCsvRequest = (data: any) => {
  return authServiceClient.post<any, AxiosResponse<any>, any>(`/property/bulk`, data);
};
